<template>
  <v-flex
    id="reflection"
    class="question"
  >
    <h2
      v-if="getReflectionQuestions.hasOwnProperty('notes')"
      class="header mb-0"
      :class="{ required: getReflectionQuestions.notes.required }"
    >
      {{ getReflectionQuestions.label }}
    </h2>
    <ul class="questions-list">
      <li class="mt-4">
        <p
          style="white-space: pre-line"
          v-html="getReflectionQuestions.notes.label"
        />
        <v-textarea
          v-model="notes"
          v-validate="{ ...requiredRegularField(getReflectionQuestions.notes.required) }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('reflection_notes')"
          :data-vv-as="' '"
          data-vv-name="reflection_notes"
          :required="getReflectionQuestions.notes.required"
          :disabled="readOnly"
        />
        <p class="mt-4 fw-400">
          {{ $t('sheet.sheet_two.reflection.hint_1') }}
        </p>
        <p class="fw-400">
          {{ $t('sheet.sheet_two.reflection.hint_2') }}
          <a
            :disabled="!isCurrentEdition || readOnly"
            @click="dialog = !readOnly"
          >{{
            $t('sheet.sheet_two.reflection.turn_off')
          }}</a>
        </p>
        <p class="fw-400">
          {{ $t('sheet.sheet_two.reflection.decision') }}
        </p>
      </li>
    </ul>
    <turnOffModal
      :visible="dialog"
      :family-id="familyId"
      :reasons-id="2"
      :get-data="false"
      @close="dialog = false"
      @reload="goToCard()"
    />
  </v-flex>
</template>

<script>
import turnOffModal from '@/components/familyCard/TurnOffModal';

import validationRules from '@/constants/validationRules';
import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
const { mapFields } = createHelpers({
    getterType: 'sheet/getSheetTwoReflectionFields',
    mutationType: 'sheet/updateSheetTwoReflectionField'
});

export default {
    name: 'SheetReflection',
    components: { turnOffModal },
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules,
            dialog: false
        };
    },
    computed: {
        ...mapFields(['notes']),
        familyId () {
            return this.$route.params.familyId;
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        ...mapGetters('sheet', ['getReflectionQuestions'])
    },
    methods: {
        goToCard () {
            this.$router.push({ name: 'family-card', params: { id: this.familyId } });
        }
    }
};
</script>

<style scoped></style>
